import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {AvailableDomain} from '../../models/cms/available-domain';

@Injectable({
  providedIn: 'root'
})
export class AvailableDomainService extends AbstractModelService<AvailableDomain> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/available-domain', AvailableDomain);
  }
}
